import { useCallback } from 'react'
import ApiService from 'services/ApiService'
import { getMessage } from 'utility/MapperResponse'
import { getTranslate } from 'utility/MapperTranslate'
import { showAlert } from 'utility/SweetAlert'

const InteractorProductItemBundlingUpdate = () => {
  const productItemBundlingUpdate = useCallback((body, callback, loading) => {
    const { alert, ...params } = body
    const payload = {
      ...params,
    }
    const isAlert = alert ?? false
    ApiService.jsonRequest('/product/bundling/update', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback()
        if (isAlert) {
          showAlert({
            icon: 'success',
            message:
              payload.is_deleted === 'Y'
                ? getTranslate('message.successfully_deleted')
                : getTranslate('message.successfully_updated'),
            timer: 2000,
          })
        }
      } else {
        showAlert({
          icon: 'error',
          message: getMessage(response?.msg),
          timer: 2000,
        })
      }
    })
  }, [])
  return { productItemBundlingUpdate }
}

export default InteractorProductItemBundlingUpdate
